import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import TransfertsPage from "../../pages/admin/Banque/BankTransactionsPage";

export default function BankTransfertsNav() {
  const [currentDirection, setCurrentDirection] = useState("");

  const onDirectionChange = (direction: string) => {
    setCurrentDirection(direction);
  };

  return (
    <Routes>
      <Route
        path="/canada-cmr"
        element={
          <TransfertsPage
            currentDirection={currentDirection || "canada-cmr-banque"}
            onDirectionChange={onDirectionChange}
          />
        }
      />
    </Routes>
  );
}
